import AddOrganization from "@/features/organizations/components/addOrg";
import Organizations from "@/features/organizations/components/orgList";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
const OrgDetail = lazy(
  () => import("@/features/organizations/components/orgDetails"),
);

const OrganizationPage = () => {
  return (
    <Routes>
      <Route path="/" element={<Organizations />} />
      <Route path="/add" element={<AddOrganization />} />
      <Route path="/:id" element={<OrgDetail />} />
    </Routes>
  );
};

export default OrganizationPage;
